import { useEffect, useState } from "react";

export const useScript = (url: string) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!url) {
      setLoading(false);
      return;
    }
    const handleScript = (e: Event) => {
      setLoading(e.type !== "load");
    };

    const script = document.createElement("script");
    script.type = "application/javascript";
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
    script.addEventListener("load", handleScript);
    script.addEventListener("error", handleScript);

    return () => {
      script.removeEventListener("load", handleScript);
      script.removeEventListener("error", handleScript);
      script.remove();
    };
  }, [url]);

  return loading;
};
